import axios from 'axios';
import {
    getTokenName,
    isPassUrls
} from './config';
import {
    Message
} from 'element-ui';

import {
    getToken,
    getTokenType,
    getBaseURL
} from '@/commons/utils';

let newUrl = '';
/**
 * 请求拦截器
 */
axios.interceptors.request.use(function (config) {
    let tokenName = getTokenName(config.url);
    config.headers[tokenName] = getToken();
    config.headers['tokenType'] = getTokenType() || '2';
    config.timeout = 30000;
    return config;
}, function (error) {
    return Promise.reject(error);
});

/**
 * 接口处理
 * @param resp
 * @param resolve
 * @param reject
 */
function successHandler (resp, resolve, reject, url) {
    if (resp.request.responseType === 'arraybuffer') {
        resolve(resp);
    } else {
        if (resp.data.code === 0 || resp.data.code === '0' || resp.data.success) {
            resolve(resp.data);
        } else {
            if (isPassUrls(resp)) {
                reject(resp.data);
            } else {
                errorHandler(reject, resp, url);
            }
        }
    }
}

/**
 * 错误接口处理
 * @param error
 * @param reject
 */
function errorHandler (reject, res, url) {
    if (url) {
        newUrl = url;
    };
    let resp = res.data;
    if (resp.message.indexOf('token') > -1 || resp.message.indexOf('Network') > -1) {
        resp.message = '登录已过期，请重新登录';
        setTimeout(() => {
            let { message } = resp;
            if (message.indexOf('登录已过期') > -1) {
                if (window.location.origin.indexOf('akctest1') > 0) {
                    window.location.href = `http://merchant-platform.akctest1.com/login.html?fromUrl=${encodeURIComponent(newUrl)}`;
                    // window.location.href = `http://localhost:9098/login.html?fromUrl=${encodeURIComponent(newUrl)}`;
                } else if (window.location.origin.indexOf('aikucun') > 0) {
                    window.location.href = `https://merc.aikucun.com/login.html?fromUrl=${encodeURIComponent(newUrl)}`;
                }
            }
        }, 2000);
    } else {
        Message({
            title: '提示',
            message: `异常信息：${resp.message || resp.data.message}`,
            type: 'error',
            duration: 2000
        });
    }
    reject(resp);
}

/**
 * 为全局对象Vue绑定$request函数
 * @param apiName
 * @param params
 * @returns {*}
 */
export const fetch = (item) => {
    return new Promise((resolve, reject) => {
        if (!item.hasOwnProperty('method') || item.method.toUpperCase() === 'GET') {
            item.params = item.hasOwnProperty('params') ? item.params : item.data;
        }
        axios(item).then(resp => {
            successHandler(resp, resolve, reject, item.fromUrl);
        }).catch(err => {
            errorHandler(reject, err, item.fromUrl);
        });
    }).finally(() => {
    });
};

export const base = getBaseURL('base');
export const uni = getBaseURL('uni');
